import { ClassifierBuilderV2Store } from "../../Stores/ClassifierBuilderV2Store";
import { useStore } from "utils/useStore";
import { Grid, useTheme } from "@mui/material";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import ClassifierBuilderDetails from "./ClassifierBuilderV2Details";
import ClassifierBuilderRuleset from "./ClassifierBuilderV2Ruleset";
import { AuthStore } from "stores/AuthStore";
import ClassifierBuilderV2Toolbar from "./ClassifierBuilderV2Toolbar";
import ClassifierGroup from "models/ClassifierGroup";
import { AsyncTaskStatus } from "stores/BaseStore";

const ClassifierBuilderTableV2Create = observer(() => {
    const theme = useTheme();
    const navigate = useNavigate();
    const store = useStore(ClassifierBuilderV2Store);
    const authStore = useStore(AuthStore);
    const orgStore = authStore.orgStore;
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState(null);
    const [group, setGroup] = useState<ClassifierGroup>();

    const onSave = async () => {
        try {
            store.setTestClassifierError("");

            let isTestValid = true;

            isTestValid = await store.validateRbcFtsSearchString();

            if (store.testClassifierError !== "" || !isTestValid) return;

            const result = await store.createClassifier(
                name,
                store.rbcSearchTermStr,
                description,
                category,
                group,
            );

            if (result !== AsyncTaskStatus.Error)
                return navigate(`../edit/${result.classifierId}`);
        } catch (error) {
            throw error;
        }
    };

    const onCategoryChange = (cat) => {
        if (cat.name === "No Selection") {
            setCategory(null);
        } else {
            setCategory(cat);
        }
    };

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    const onNameChange = (e) => {
        setName(e.target.value);
    };

    useEffect(() => {
        if (orgStore && orgStore.selectedOrganization) {
            store.orgSelectStore.selectOrg(orgStore.selectedOrganization);
            store.setRbcSearchTermStr(store?.rbcSearchTermStr ?? "");
        }
    }, [orgStore, orgStore?.selectedOrganization, store]);

    return (
        <Grid container direction="column">
            <Grid item>
                <ClassifierBuilderV2Toolbar
                    store={store}
                    onSave={onSave}
                    disableSave={!name || !store.rbcSearchTermStr}
                    disableCopy
                />
            </Grid>
            <Grid
                item
                container
                direction="column"
                sx={{
                    paddingLeft: theme.spacing(20),
                    paddingRight: theme.spacing(20),
                    paddingTop: theme.spacing(3),
                    height: "calc(100% - 64px)",
                }}
                rowGap={2}
            >
                <ClassifierBuilderDetails
                    name={name}
                    description={description}
                    category={category}
                    onNameChange={onNameChange}
                    onDescriptionChange={onDescriptionChange}
                    onCategoryChange={onCategoryChange}
                    group={group}
                    onGroupChange={setGroup}
                    modifiedOn={store.selectedClassifier?.modifiedOn}
                    isSmartPredictActive={
                        store.selectedClassifier
                            ? store.selectedClassifier
                                  .classifierResultAnswerTags.length > 1
                            : false
                    }
                />
                <ClassifierBuilderRuleset />
            </Grid>
        </Grid>
    );
});

export default ClassifierBuilderTableV2Create;
